<template lang="html">
	<common-card class-name="omapi-settings-upgrade">
		<p v-if="connected">Thank you for being a loyal OptinMonster Lite user.</p>

		<p class="omapi-settings-upgrade__title">
			Upgrade to OptinMonster Pro and unlock even more conversion features!
		</p>

		<p class="omapi-settings-upgrade__coupon">
			Use coupon code
			<span class="omapi-settings-upgrade__coupon-code"> LITEUPGRADE </span>
			to get 35% off.
		</p>

		<p>Discount is automatically applied at checkout.</p>

		<ul class="omapi-settings-upgrade__features">
			<li>Exit Intent® Technology</li>
			<li>OnSite Retargeting®</li>
			<li>Spin-a-Wheel Campaigns</li>
			<li>Campaign Scheduling</li>
			<li>MonsterLinks™</li>
			<li>Countdown Timers</li>
		</ul>

		<core-upgrade-button color="green" size="large" utm-medium="SettingsProUpsell">
			Upgrade to OptinMonster Pro
		</core-upgrade-button>
	</common-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['connected']),
	},
};
</script>
